import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@mui/material";
import Sidebar from "./SidebarHeader";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "../../assets/theme";
import "../../assets/base.css";

createRoot(document.getElementById("ahg-sidebar-header")).render(
	<StrictMode>
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<Sidebar />
		</ThemeProvider>
	</StrictMode>
);
